import andType from 'owa-service/lib/factory/and';
import constant from 'owa-service/lib/factory/constant';
import fieldURIOrConstantType from 'owa-service/lib/factory/fieldURIOrConstantType';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import isEqualTo from 'owa-service/lib/factory/isEqualTo';
import isNotEqualTo from 'owa-service/lib/factory/isNotEqualTo';
import orType from 'owa-service/lib/factory/or';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import restrictionType from 'owa-service/lib/factory/restrictionType';
export var EXCLUDED_FOLDERS = [
    'deleteditems',
    'conversationhistory',
    'teamchat',
];
export function createSearchPersonaRestriction(allEmailAddresses) {
    // A. Include items if displayName matches or any of the emails matches "From"
    var searchRestriction = orType({
        Items: allEmailAddresses.map(function (email) { return isEqualRestriction(email, 'From'); }),
    });
    // B. Don't include items from EXCLUDED_FOLDERS
    var excludedFoldersRestriction = andType({
        Items: EXCLUDED_FOLDERS.map(function (folderName) {
            var folderId = folderNameToId(folderName);
            return negativeRestriction(folderId, 'ParentFolderId');
        }),
    });
    // Return items only if A. and B. conditions are satisfied
    var restrictions = andType({
        Items: [searchRestriction, excludedFoldersRestriction],
    });
    return restrictionType({
        Item: restrictions,
    });
}
function isEqualRestriction(value, fieldURI) {
    return isEqualTo({
        FieldURIOrConstant: fieldURIOrConstantType({
            Item: constant({
                Value: value,
            }),
        }),
        Item: propertyUri({
            FieldURI: fieldURI,
        }),
    });
}
function negativeRestriction(value, fieldURI) {
    return isNotEqualTo({
        FieldURIOrConstant: fieldURIOrConstantType({
            Item: constant({
                Value: value,
            }),
        }),
        Item: propertyUri({
            FieldURI: fieldURI,
        }),
    });
}
//# sourceMappingURL=createSearchPersonaRestriction.js.map